
import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Logo from '../../components/Logo';
import NavLink from '../../components/NavLink';

export default function Gallery() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState('All');

  // Persist theme preference
  useEffect(() => {
    const savedTheme = localStorage.getItem('theme');
    if (savedTheme === 'dark') {
      document.documentElement.classList.add('dark');
    }
  }, []);

  const categories = ['All', 'Clothing', 'Jewelry', 'Home Decor', 'Artisans at Work'];

  const galleryItems = [
    {
      category: 'Clothing',
      title: 'Traditional African Clothing Collection',
      image: '/niza%20(1).jpeg',
      description: 'Beautiful collection of traditional African clothing with vibrant patterns and colors'
    },
    {
      category: 'Jewelry',
      title: 'Beaded Necklace Collection',
      image: '/niza%20(2).jpeg',
      description: 'Colorful beaded necklaces with traditional patterns'
    },
    {
      category: 'Home Decor',
      title: 'Wall Hanging Art',
      image: '/niza%20(3).jpeg',
      description: 'Handcrafted wall art featuring traditional African motifs'
    },
    {
      category: 'Artisans at Work',
      title: 'Beadwork in Progress',
      image: '/niza%20(4).jpeg',
      description: 'Our skilled artisans creating beautiful beadwork'
    },
    {
      category: 'Clothing',
      title: 'Contemporary African Outfit',
      image: '/niza%20(5).jpeg',
      description: 'Modern African-inspired fashion with traditional elements'
    },
    {
      category: 'Jewelry',
      title: 'Traditional Bangles',
      image: '/niza_logo.jpeg',
      description: 'Handmade beaded bangles in vibrant colors'
    },
    {
      category: 'Jewelry',
      title: 'Beaded Handbag Collection',
      image: '/niza%20(1).jpeg',
      description: 'Stylish beaded handbags with vibrant pom-pom accents and traditional patterns'
    },
    {
      category: 'Home Decor',
      title: 'Hand-painted Fabric',
      image: '/niza%20(2).jpeg',
      description: 'Beautiful hand-painted fabric for home decoration'
    },
    {
      category: 'Artisans at Work',
      title: 'Community Workshop',
      image: '/niza%20(3).jpeg',
      description: 'Women learning and sharing traditional craft skills'
    },
    {
      category: 'Clothing',
      title: 'Traditional Shirt Set',
      image: '/niza%20(4).jpeg',
      description: 'Comfortable traditional clothing with cultural patterns'
    },
    {
      category: 'Jewelry',
      title: 'Doek and Scarf Set',
      image: '/niza%20(5).jpeg',
      description: 'Traditional headwrap accessories with matching scarves'
    },
    {
      category: 'Home Decor',
      title: 'Decorative Baskets',
      image: '/niza_logo.jpeg',
      description: 'Woven decorative baskets with traditional patterns'
    },
    {
      category: 'Jewelry',
      title: 'Handcrafted Shopping Bag Collection',
      image: '/niza%20(1).jpeg',
      description: 'Beautiful eco-friendly shopping bags with traditional African patterns and kente cloth designs'
    },
    {
      category: 'Artisans at Work',
      title: 'Fabric Painting',
      image: '/niza%20(2).jpeg',
      description: 'Artist creating hand-painted fabric designs'
    },
    {
      category: 'Home Decor',
      title: 'African Portrait Collection',
      image: '/niza%20(3).jpeg',
      description: 'Beautiful framed African portrait artwork showcasing traditional beadwork and cultural heritage'
    }
  ];

  const filteredItems = selectedCategory === 'All'
    ? galleryItems
    : galleryItems.filter(item => item.category === selectedCategory);

  return (
    <div className="min-h-screen bg-white  transition-colors" style={{ fontFamily: 'Prompt, sans-serif' }}>
      {/* Navigation */}
      <nav className="absolute top-0 left-0 right-0 z-50 bg-transparent">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-start py-4">
            <div className="flex items-start">
              <Link to="/">
                <Logo size="md" className="hover:scale-105 transition-transform cursor-pointer" />
              </Link>
            </div>

            <div className="hidden md:block">
              <div className="ml-10 flex items-baseline space-x-8 pt-4">
                <NavLink to="/">HOME</NavLink>
                <NavLink to="/about">ABOUT</NavLink>
                <NavLink to="/products">PRODUCTS</NavLink>
                <NavLink to="/gallery">GALLERY</NavLink>
                <NavLink to="/contact">CONTACT</NavLink>
              </div>
            </div>

            <div className="hidden md:flex items-center space-x-4 pt-4">
              <a href="/products" className="bg-zbm-secondary hover:bg-zbm-secondary-dark text-white px-6 py-2 rounded-full text-sm font-medium transition-colors whitespace-nowrap cursor-pointer drop-shadow-lg">
                Explore Collection
              </a>
            </div>

            <div className="md:hidden">
              <button
                onClick={() => setIsMenuOpen(!isMenuOpen)}
                className="text-zbm-primary hover:text-zbm-primary-dark cursor-pointer drop-shadow-lg"
              >
                <i className="ri-menu-line text-xl"></i>
              </button>
            </div>
          </div>
        </div>

        {/* Mobile menu */}
        {isMenuOpen && (
          <div className="md:hidden">
            <div className="px-2 pt-2 pb-3 space-y-1 sm:px-3 bg-white/95 /95 backdrop-blur-sm border-t border-gray-100 ">
              <NavLink to="/" mobile={true}>HOME</NavLink>
              <NavLink to="/about" mobile={true}>ABOUT</NavLink>
              <NavLink to="/products" mobile={true}>PRODUCTS</NavLink>
              <NavLink to="/gallery" mobile={true}>GALLERY</NavLink>
              <NavLink to="/contact" mobile={true}>CONTACT</NavLink>
              <a href="/products" className="bg-zbm-secondary hover:bg-zbm-secondary-dark text-white px-6 py-2 rounded-full text-sm font-medium transition-colors whitespace-nowrap cursor-pointer w-full mt-2">
                Explore Collection
              </a>
            </div>
          </div>
        )}
      </nav>

      {/* Header Separator Line */}
      <div className="w-full h-px bg-gray-300 mt-32"></div>
      {/* Hero Section */}
      <section className="relative pt-20 pb-20" style={{ backgroundColor: '#F7F7F7' }}>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-4xl lg:text-6xl font-extrabold text-gray-900  mb-6" style={{ fontFamily: 'Prompt, sans-serif' }}>
            Our
            <span className="text-zbm-primary block">Gallery</span>
          </h1>
          <p className="text-xl text-gray-600  mb-8 max-w-3xl mx-auto leading-relaxed font-normal">
            Experience the beauty of African artistry through our handcrafted pieces. From intricate beadwork to vibrant textiles, every item reflects creativity, identity, and pride.
          </p>
          <div className="flex items-center justify-center mb-8">
            <span className="text-2xl mr-3">📸</span>
            <p className="text-lg font-semibold text-gray-700 ">A Glimpse into Our Creations</p>
          </div>
        </div>
      </section>

      {/* Filter Section */}
      <section className="py-12 bg-white ">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex flex-wrap justify-center gap-4">
            {categories.map((category) => (
              <button
                key={category}
                onClick={() => setSelectedCategory(category)}
                className={`px-6 py-3 rounded-full text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                  selectedCategory === category
                    ? 'bg-zbm-primary text-white'
                    : 'bg-gray-100  text-gray-700  hover:bg-zbm-light dark:hover:bg-gray-700'
                }`}
              >
                {category}
              </button>
            ))}
          </div>
        </div>
      </section>

      {/* Gallery Grid */}
      <section className="py-20 bg-gradient-to-br from-gray-50 to-zbm-light dark:from-gray-800 dark:to-gray-900">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-8">
            {filteredItems.map((item, index) => (
              <div
                key={index}
                className="bg-white  rounded-2xl shadow-lg overflow-hidden hover:shadow-xl transition-shadow cursor-pointer group"
              >
                <div className="relative overflow-hidden">
                  <img
                    src={item.image}
                    alt={item.title}
                    className="w-full h-64 object-cover group-hover:scale-105 transition-transform duration-300"
                    onError={(e) => {
                      // Fallback image if loading fails
                      e.currentTarget.src = 'https://via.placeholder.com/400x300?text=Image+Unavailable';
                    }}
                  />
                  <div className="absolute inset-0 bg-black bg-opacity-0 group-hover:bg-opacity-30 transition-opacity duration-300 flex items-center justify-center">
                    <i className="ri-eye-line text-white text-2xl opacity-0 group-hover:opacity-100 transition-opacity duration-300"></i>
                  </div>
                </div>
                <div className="p-6">
                  <div className="flex items-center mb-2">
                    <span className="text-xs font-medium text-zbm-primary bg-sky-100 dark:bg-sky-900 px-2 py-1 rounded-full">
                      {item.category}
                    </span>
                  </div>
                  <h3 className="text-lg font-bold text-gray-900  mb-2" style={{ fontFamily: 'Prompt, sans-serif' }}>{item.title}</h3>
                  <p className="text-gray-600  text-sm font-normal">{item.description}</p>
                </div>
              </div>
            ))}

            {/* Additional static cards */}
            <div className="bg-gradient-to-br from-zbm-light to-white dark:from-gray-800 dark:to-gray-700 rounded-2xl shadow-lg overflow-hidden hover:shadow-xl transition-shadow cursor-pointer">
              <img
                src="/niza%20(4).jpeg"
                alt="African Portrait Art Collection"
                className="w-full h-48 object-cover"
              />
              <div className="p-6">
                <h3 className="text-lg font-bold text-gray-900  mb-2" style={{ fontFamily: 'Prompt, sans-serif' }}>African Portrait Art</h3>
                <p className="text-gray-600  text-sm font-normal">
                  Stunning framed artwork celebrating African beauty and culture
                </p>
              </div>
            </div>

            <div className="bg-gradient-to-br from-zbm-light to-white dark:from-gray-800 dark:to-gray-700 rounded-2xl shadow-lg overflow-hidden hover:shadow-xl transition-shadow cursor-pointer">
              <img
                src="/niza%20(5).jpeg"
                alt="Vibrant Textiles"
                className="w-full h-48 object-cover"
              />
              <div className="p-6">
                <h3 className="text-lg font-bold text-gray-900  mb-2" style={{ fontFamily: 'Prompt, sans-serif' }}>Vibrant Textiles</h3>
                <p className="text-gray-600  text-sm font-normal">
                  Rich fabrics telling stories of our heritage
                </p>
              </div>
            </div>

          </div>
        </div>
      </section>

      {/* Process Section */}
      <section className="py-20 bg-white ">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-3xl lg:text-4xl font-bold text-gray-900  mb-6" style={{ fontFamily: 'Prompt, sans-serif' }}>Our Creative Process</h2>
            <p className="text-xl text-gray-600  max-w-3xl mx-auto font-normal">
              From concept to creation, every piece goes through a careful process of traditional craftsmanship.
            </p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
            <div className="text-center">
              <div className="w-16 h-16 bg-zbm-primary rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-lightbulb-line text-2xl text-white"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900  mb-2" style={{ fontFamily: 'Prompt, sans-serif' }}>1. Design</h3>
              <p className="text-gray-600  font-normal">Creating unique designs inspired by African heritage</p>
            </div>
            <div className="text-center">
              <div className="w-16 h-16 bg-zbm-secondary rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-palette-line text-2xl text-white"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900  mb-2" style={{ fontFamily: 'Prompt, sans-serif' }}>2. Materials</h3>
              <p className="text-gray-600  font-normal">Selecting quality fabrics and authentic beads</p>
            </div>
            <div className="text-center">
              <div className="w-16 h-16 bg-zbm-primary rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-hand-heart-line text-2xl text-white"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900  mb-2" style={{ fontFamily: 'Prompt, sans-serif' }}>3. Crafting</h3>
              <p className="text-gray-600  font-normal">Handcrafting with traditional techniques and care</p>
            </div>
            <div className="text-center">
              <div className="w-16 h-16 bg-zbm-secondary rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-star-line text-2xl text-white"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900  mb-2" style={{ fontFamily: 'Prompt, sans-serif' }}>4. Finishing</h3>
              <p className="text-gray-600  font-normal">Quality checking and final touches</p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20" style={{ background: 'linear-gradient(to right, #1E3A8A, #EA580C)' }}>
        <div className="max-w-4xl mx-auto text-center px-4 sm:px-6 lg:px-8">
          <h2 className="text-3xl lg:text-4xl font-bold text-white mb-6" style={{ fontFamily: 'Prompt, sans-serif' }}>
            Love What You See?
          </h2>
          <p className="text-xl text-white mb-8 leading-relaxed font-normal" style={{ opacity: 0.95 }}>
            Browse our collection and find the perfect piece that speaks to you. Each creation is a celebration of African culture, crafted with love by our talented artisans.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a href="/products" className="bg-white text-zbm-primary hover:bg-gray-50 px-8 py-4 rounded-full text-lg font-semibold transition-colors whitespace-nowrap cursor-pointer">
              Shop Products
            </a>
            <a href="/contact" className="border-2 border-white text-white hover:bg-white hover:text-zbm-primary px-8 py-4 rounded-full text-lg font-semibold transition-colors whitespace-nowrap cursor-pointer">
              Contact Us
            </a>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-gray-900 text-white py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
            {/* About / Social */}
            <div className="lg:col-span-2">
              <h3 className="text-2xl font-bold mb-4" style={{ fontFamily: 'Prompt, sans-serif' }}>
                ZBM Projects
              </h3>
              <p className="text-gray-300 mb-6 max-w-md font-normal">
                A 100% Black-owned private company specializing in prefabricated structures, civil and building construction projects. Delivering high-quality infrastructure solutions across South Africa.
              </p>
              <div className="flex space-x-4">
                <a
                  href="#"
                  className="w-10 h-10 bg-zbm-primary hover:bg-zbm-primary-dark rounded-full flex items-center justify-center transition-colors"
                  aria-label="Facebook"
                >
                  <i className="ri-facebook-fill"></i>
                </a>
                <a
                  href="#"
                  className="w-10 h-10 bg-zbm-secondary hover:bg-zbm-secondary-dark rounded-full flex items-center justify-center transition-colors"
                  aria-label="LinkedIn"
                >
                  <i className="ri-linkedin-fill"></i>
                </a>
                <a
                  href="#"
                  className="w-10 h-10 bg-green-500 hover:bg-green-600 rounded-full flex items-center justify-center transition-colors"
                  aria-label="WhatsApp"
                >
                  <i className="ri-whatsapp-line"></i>
                </a>
              </div>
            </div>

            <div>
              <h4 className="text-lg font-semibold mb-4" style={{ fontFamily: 'Prompt, sans-serif' }}>Services</h4>
              <ul className="space-y-2 text-gray-300 font-normal">
                <li><Link to="/services" className="hover:text-zbm-primary-light transition-colors cursor-pointer">Project Management</Link></li>
                <li><Link to="/services" className="hover:text-zbm-primary-light transition-colors cursor-pointer">Building Construction</Link></li>
                <li><Link to="/services" className="hover:text-zbm-primary-light transition-colors cursor-pointer">Civil Engineering</Link></li>
                <li><Link to="/services" className="hover:text-zbm-primary-light transition-colors cursor-pointer">Prefabricated Structures</Link></li>
                <li><Link to="/services" className="hover:text-zbm-primary-light transition-colors cursor-pointer">Water Infrastructure</Link></li>
              </ul>
            </div>

            <div>
              <h4 className="text-lg font-semibold mb-4" style={{ fontFamily: 'Prompt, sans-serif' }}>Company</h4>
              <ul className="space-y-2 text-gray-300 font-normal">
                <li><Link to="/" className="hover:text-zbm-primary-light transition-colors cursor-pointer">Home</Link></li>
                <li><Link to="/about" className="hover:text-zbm-primary-light transition-colors cursor-pointer">About Us</Link></li>
                <li><Link to="/about#team" className="hover:text-zbm-primary-light transition-colors cursor-pointer">Our Team</Link></li>
                <li><Link to="/products" className="hover:text-zbm-primary-light transition-colors cursor-pointer">Projects</Link></li>
                <li><Link to="/contact" className="hover:text-zbm-primary-light transition-colors cursor-pointer">Contact Us</Link></li>
              </ul>
            </div>

          </div>

          <div className="border-t border-gray-800 mt-12 pt-8 flex flex-col md:flex-row justify-between items-center">
            <p className="text-gray-400 text-sm font-normal">
              © 2025 ZBM Projects. All Rights Reserved. Reg: 2016/321746/07
            </p>
          </div>
        </div>
      </footer>
    </div>
  );
}
